import Vue from 'vue';

// local state
const getDefaultState = () => {
    return {
        user: {
            registration_complete: false,
            auth: false,
            email: '',
            first_name: '',
            last_name: '',
            countries_id: '',
            articles: [],
            countries_price:'',
        },
        session: null,
        needLogin: false,
        projectData: [],
        formData: {
            company_types: [],
            contact_types: [],
            countries: [],
            languages:[],
            salutations: [],
            titles: [],
            units:[]


        },
        persistedstatate: 0,
        configuration: null,
        selectedlocale: {
            country: 'deu',
            language:'de'
        },
       // projectTmp:{}

    }
};

const state = getDefaultState()

const getters = {

};

const mutations = {
    persisdateData(state) {
        state.persistedstatate++
    },
    updateUser(state, user) {
        console.log('Mutation User')
        console.log(user)
        state.user = user
    },
    updateSession(state, session) {
        state.session = session
    },
    updateNeedLogin(state, session) {
        state.needLogin = session
    },
    updateFormData(state, formData) {
        state.formData = formData
    },
    updateProjectData(state, projectData) {
        state.projectData = projectData
    },
    updateConfiguration(state, configuration) {
        state.configuration = configuration
    },
    updateSelectedlocale(state, selectedvalues) {
        state.selectedlocale = selectedvalues
    },
   /*  updateProjectTmp(state, project) {
        state.projectTmp = project
    }, */
    resetState(state) {
        Object.assign(state, getDefaultState())
    }
};

const actions = {
    resetState({ commit }) {
        commit('resetState')
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
